import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import { Typography, Button, Stack, CircularProgress } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  dialogRoot: {
    backgroundColor: "transparent",
  },
  newPosOfDialog: {
    padding: 32,
    maxWidth: 500,
    minHeight: 200,
    backgroundColor: "#FFFFFF",
    border: `2px solid ${theme.palette.divider}`,
    borderRadius: 15,
  },
  dialogTitle: {
    marginBottom: "24px",
    fontSize: "1.2500em",
  },
  timeText: {
    fontWeight: theme.typography.fontWeightBold,
  },
  buttonNo: {
    //padding: "16px 32px",
    marginLeft: "auto",
    backgroundColor: "#D8D8D8",
    color: theme.palette.text.primary,
    "&:hover": {
      backgroundColor: "#C9C8C8",
    },
  },
  buttonYes: {
    marginLeft: "1em",
    //padding: 0
  },
}));

export interface SessionExtensionDialogProps {
  showExtensionDialog: boolean;
  exp: number | null;
  timeRemaining: string;
  handleLogOut: () => void;
  handleExtend: () => void;
  isLoggingOut?: boolean;
}

export const SessionExtensionDialog = (props: SessionExtensionDialogProps) => {
  const classes = useStyles();
  const { handleLogOut, handleExtend, timeRemaining, showExtensionDialog, isLoggingOut } =
    props;

  // State to hold the formatted time remaining

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="sm"
        classes={{
          paper: classes.newPosOfDialog,
        }}
        // onClose={(event, reason) => {
        //   // @ts-ignore
        //   event.stopPropagation();
        //   if (reason === "backdropClick" || reason === "escapeKeyDown")
        //     return;
        // }}
        aria-labelledby="session-extension-dialog"
        open={showExtensionDialog}>
        <Typography
          variant="h4"
          className={classes.dialogTitle}
          id="session-extension-dialog">
          Session ending soon
        </Typography>
        <Typography variant="body2" sx={{ marginBottom: "1em" }}>
          For your security, sessions automatically end after 3 hours unless you choose to
          stay logged in.
        </Typography>
        <Typography variant="body2" sx={{ marginBottom: "32px" }}>
          Your session ends in{" "}
          <span className={classes.timeText}>{timeRemaining} minutes</span>.
        </Typography>
        <Stack direction="row" justifyContent="space-between">
          <Button
            onClick={handleLogOut}
            variant="contained"
            color="primary"
            size="large"
            className={classes.buttonNo}
            disabled={isLoggingOut}
            aria-label={isLoggingOut ? "Logging out" : "Log out"}>
            {isLoggingOut ? (
              <CircularProgress size={18} color="inherit" aria-hidden="true" />
            ) : (
              "Log out"
            )}
          </Button>

          {/** If the token refresh remaining is greater than 0, show the extend button */}
          <Button
            onClick={() => {
              handleExtend();
            }}
            variant="contained"
            color="primary"
            size="large"
            className={classes.buttonYes}>
            Stay logged in
          </Button>
        </Stack>
      </Dialog>
    </>
  );
};
